/**
 * File: apps/qbench-cp/reactapp/src/shared/components/FormV2/Label.js
 *
 * Purpose: Renders the field label shown above (or beside) FormV2 input components.
 *
 * Scope: FormV2 field label rendering.
 *
 * Tags: customer-portal
 *
 * Overview: Exports Label, which renders nothing for BOOL fields (since Checkbox renders its
 *     own inline label) and otherwise renders a styled label with uppercase/muted styling,
 *     appending a red asterisk when `required` is true and applying `aria-disabled` plus muted
 *     styling when `readOnly` is true.
 *
 * Exports: default Label component.
 */

import classNames from 'classnames';
import styled from 'styled-components';
import { domProps } from 'shared/utils/form';
import { AddlFieldType } from 'shared/constants/fields';

const StyledLabel = styled.label`
  color: ${(p) => p.theme.color.palette.text.main};
`;

export default function Label({
  fieldType = '',
  required = false,
  readOnly = false,
  children,
  ...props
}) {
  if (fieldType === AddlFieldType.BOOL) return null;
  return (
    <StyledLabel
      className={classNames(
        'fs-8 fw-medium lh-1 ls-1 text-uppercase',
        readOnly && 'text-muted cursor-not-allowed',
      )}
      aria-disabled={readOnly}
      {...domProps(props)}
    >
      {children}
      {required && <span className="text-danger">&nbsp;*</span>}
    </StyledLabel>
  );
}
